import DownloadReportScreen from "@/components/reports/DownloadReportScreen.vue";
import {downloadXLSX} from "@/utils/helpers.js";

/** Выбор формата и скачивание отчетов, общие для отчетов по одной и нескольким камерам. */
export const downloadReportMixin = {
  methods: {
    openDownloadReportScreen() {
      this.$camsdals.open(
        DownloadReportScreen,
        {},
        {dialogTitle: this.$t('downloadReport')},
        {
          size: "vuedal-auto-width",
          name: "js-click-outside",
          onClose: (format) => {
            if (format === "xlsx") {
              this.downloadTableAsXLSXReport();
            } else if (format === "csv") {
              this.downloadTableAsCSVReport();
            }
          },
        },
      );
    },

    async downloadReportAsXLSX(method, filename, params = {}) {
      const response = await this.$store.getters.ajaxClient.post("/v0/data/to_xlsx/", {
        method,
        ...params,
      }, {
        responseType: "arraybuffer",
      });
      const fileData = response.data;
      if (!fileData || fileData.byteLength === 0) {
        throw new Error(this.$t('archiveError'));
      }
      downloadXLSX(filename, fileData);
    },
  },
};
